(function Module() {
	'use strict';

	mySynch.controller('SiresDashboardController', [
		'$scope',
		'MySynchFactory',
		'ApiFactory',
		'clientLoggerService',
		function SiresDashboardController($s, MSF, api, log) {
			var self = this;
			self.loading = true;
			self.reportRows = [];
			self.dataUpdatedDate = null;
			self.isTotalRow = rowIsTotal;
			self.concepDataCode = "CR-bySire";

			function formattedRate(rate) {
				return _.isNumber(rate) ? _.round(rate * 100, 1) + '%' : rate;
			}

			function formattedDecimal(val) {
				return (!_.isNumber(val) || _.isNaN(val)) ? val : _.round(val, 1);
			}

			function formatReportLineItems(lineItems) {
				var sireName = _.trim(_.get(lineItems, 'code'));
				var confInterval =   _.trim(_.get(lineItems,'cI_95_display',""));
				var conceptionRate = _.get(lineItems, 'concPerc', 0);
				var pregnancyCount = _.get(lineItems, 'pregCount', 0);
				var openCount = _.get(lineItems, 'openCount', 0);
				var otherCount = _.get(lineItems, 'otherCount', 0);
				var abortCount = _.get(lineItems, 'abortCount', 0);
				var totalCount = _.get(lineItems, 'totalCount', 0);
				var percentOfTotal = _.get(lineItems, 'totalPerc', 0);
				var servicesPerConception = _.get(lineItems, 'servicesPerConcep', 0);

				var formattedRowData = {
					sireName: sireName,
					confInterval: confInterval,
					conceptionRate: formattedRate(conceptionRate),
					pregnancyCount: pregnancyCount,
					openCount: openCount,
					otherCount: otherCount,
					abortCount: abortCount,
					totalCount: totalCount,
					percentOfTotal: formattedRate(percentOfTotal),
					servicesPerConception: formattedDecimal(servicesPerConception)
				};

				return formattedRowData;
			}

			function rowIsTotal(row) {
				return row.sireName.toLowerCase() === 'totals';
			}

			function rowIsOther(row) {
				return row.sireName.toLowerCase() === 'others';
			}

			function loadReportData() {
				self.loading = true;
				self.reportRows = [];
				self.incompleteSetupMessage = '';

				var herdId = MSF.getActiveHerd().herdId;

				api.getHerdConcepDataByCodeAndHerdId(herdId,self.concepDataCode, function gotSireReportData(err, results) {
					self.loading = false;

					if (err) {
						self.reportRows = [];
						log.error({error: err}, 'Error getting sire fertility data');

						if (results.statusCode === 403) { // 403 indicates setup is not complete and should have display message in response
							self.incompleteSetupMessage = results.statusText;
						}

						return;
					}

					var reportData = results;

					var formattedRows = _.map(reportData, formatReportLineItems);

					var othersRow = _.remove(formattedRows, rowIsOther);
					var totalRow = _.remove(formattedRows, rowIsTotal);

					var sortedRows = _.sortBy(formattedRows, 'sireName');

					var allRows = sortedRows.concat(othersRow).concat(totalRow);

					self.reportRows = allRows;
					
				});
			}

			MSF.ready(function onMsfReady() {
				
				var currentActiveHerdId = _.get(MSF.getActiveHerd(), 'herdId');
				var currentActiveHerdAdditionalHerdData = MSF.getAdditionalHerdDataItem(currentActiveHerdId);
                var metaLastEventDateString = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.metaLastEventDate');
                self.dataUpdatedDate = !_.isUndefined(metaLastEventDateString) ? moment(metaLastEventDateString).format(MSF.i18n.format.dateLong) : '';
				loadReportData();

				$s.$on('herd:changed', function herdChanged() {
					
					var currentActiveHerdId = _.get(MSF.getActiveHerd(), 'herdId');
				    var currentActiveHerdAdditionalHerdData = MSF.getAdditionalHerdDataItem(currentActiveHerdId);
					var metaLastEventDateString = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.metaLastEventDate');
					self.dataUpdatedDate = !_.isUndefined(metaLastEventDateString) ? moment(metaLastEventDateString).format(MSF.i18n.format.dateLong) : '';
					loadReportData();
				});
			});

			// Code supporting the display of reasons for 403 when viewing dashboard
			self.incompleteSetupMessage = '';
			self.setupIsIncomplete = function setupIsIncomplete() {
				return self.incompleteSetupMessage !== '';
			};
			self.getIncompleteSetupMessages = function getIncompleteSetupMessages() {
				return self.incompleteSetupMessage.split('|');
			};
			self.getTerritoryManager = function getTerritoryManager() {
				return MSF.getActiveFarmTerritoryManager();
			};
			// Add these to the scope so they are visible to the mixin
			$s.setupIsIncomplete = self.setupIsIncomplete;
			$s.getIncompleteSetupMessages = self.getIncompleteSetupMessages;
			$s.getTerritoryManager = self.getTerritoryManager;
		}
	]);
})();
